import { render, staticRenderFns } from "./ChooseRide.vue?vue&type=template&id=388782f9&scoped=true&"
import script from "./ChooseRide.vue?vue&type=script&lang=js&"
export * from "./ChooseRide.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRide.vue?vue&type=style&index=0&id=388782f9&scoped=true&lang=scss&"
import style1 from "./ChooseRide.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388782f9",
  null
  
)

export default component.exports